'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:RoomDetailsController
 * @description
 * # RoomDetailsController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('RoomDetailsController', ['$scope', 'TALocationService', 'TodaysAssignments', 'Constants',
      function ($scope, TALocationService, TodaysAssignments, Constants) {

      $scope.todaysAssignments = new TodaysAssignments($scope, Constants.TodaysAssignments.Levels.RoomGroups);

      $scope.back = function () {
          TALocationService.GoToTheHomePage();
      };

      $scope.startWorking = function () {
          $scope.todaysAssignments.StartWorking();
      };

      $scope.markComplete = function (activity) {
          $scope.todaysAssignments.MarkComplete(activity);
      };

      $scope.toggleRoomInstructions = function () {
          $scope.hideRoomInstructions = !$scope.hideRoomInstructions;
      };

      $scope.openRackCensusForm = function (facilityId, roomId) {
          $scope.todaysAssignments.dataLoaded = false;
          TALocationService.GoToTheRackCensus(facilityId, roomId);
      };

      $scope.openActivity = function (activity) {
          if (activity.name !== 'Ad Hoc Counts') {
              $scope.todaysAssignments.dataLoaded = false;
              TALocationService.GoToTheActivityDetails(activity.scheduleId);
          }
      };

      $scope.openPreparationList = function (facilityId, roomId) {
          $scope.todaysAssignments.dataLoaded = false;
          TALocationService.GoToThePreparationList(facilityId, roomId);
      };

      $scope.isRackCompleted = function (rack) {
          return rack.activities.every(function (activity) {
              return activity.progressStatusName === $scope.todaysAssignments.progressStatuses.StatusNamesConstants.Completed;
          }) && rack.adHocCountActivities.every(function (activity) {
              return activity.progressStatusName === $scope.todaysAssignments.progressStatuses.StatusNamesConstants.Completed;
          });
      };

      $scope.isRoomCompleted = function () {
          var allRoomActivitiesOnlyAssignedToMe = getRoomActivitiesOnlyAssignedToMe($scope.todaysAssignments.roomActivitiesGroups);

          return $scope.isRackCompleted(allRoomActivitiesOnlyAssignedToMe);
      };

      $scope.CompleteAllRacks = function () {
          var allRoomActivitiesOnlyAssignedToMe = getRoomActivitiesOnlyAssignedToMe($scope.todaysAssignments.roomActivitiesGroups);

          $scope.todaysAssignments.CompleteRack(allRoomActivitiesOnlyAssignedToMe);
      };

      function getRoomActivitiesOnlyAssignedToMe(roomActivitiesGroups) {
          var allRoomActivitiesOnlyAssignedToMe = { activities: [], adHocCountActivities: [] };

          roomActivitiesGroups.forEach(function (roomActivitiesGroup) {
              var roomActivitiesGroupWithOnlyAssignedToMe = roomActivitiesGroup.activities.filter(activity => { return activity.isAssignedToMe; });

              roomActivitiesGroupWithOnlyAssignedToMe.forEach(function (myActivity) {
                  allRoomActivitiesOnlyAssignedToMe.activities.push(myActivity);
              });

              if (roomActivitiesGroup.adHocCountActivities && roomActivitiesGroup.adHocCountActivities.length) {
                  var roomAdHocCountActivitiesGroupWithOnlyAssignedToMe = roomActivitiesGroup.adHocCountActivities.filter(activity => { return activity.isAssignedToMe; });

                  roomAdHocCountActivitiesGroupWithOnlyAssignedToMe.forEach(function (myAdHocCountActivity) {
                      allRoomActivitiesOnlyAssignedToMe.adHocCountActivities.push(myAdHocCountActivity);
                  });
              }
          });

          return allRoomActivitiesOnlyAssignedToMe;
      }

      function init() {
          $scope.todaysAssignments.LoadRoomData();

          $scope.hideRoomInstructions = false;
      }

      init();

      $scope.$on('$destroy', function () {
          $scope.todaysAssignments.closeSignalRConnection();
      });

  }]);
